module.exports = __webpack_public_path__ + "img/dean-saunders.119186d8.jpg";